import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsConsentEvent, trackPageView } from '../utils/analytics';

export default function AnalyticsManager() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const sendPageView = () => trackPageView(`${pathname}${search}`, document.title);
    sendPageView();
    window.addEventListener(analyticsConsentEvent, sendPageView);
    return () => window.removeEventListener(analyticsConsentEvent, sendPageView);
  }, [pathname, search]);

  return null;
}
